import "./Footer.css";

function Footer() {
  return (
    <div className="Footer">
      <p>© 2020 Whichride - All rights reserved. </p>
      <p>Privacy Policy &nbsp; &nbsp;Terms and Conditions</p>
    </div>
  );
}

export default Footer;
